import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import payments4e2b3d from './payments'
import contributions from './contributions'
import inbox43de3a from './inbox'
/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
export const overview = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: overview.url(options),
    method: 'get',
})

overview.definition = {
    methods: ["get","head"],
    url: '/app/member',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
overview.url = (options?: RouteQueryOptions) => {
    return overview.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
overview.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: overview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
overview.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: overview.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
const overviewForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: overview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
overviewForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: overview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::overview
* @see app/Http/Controllers/Member/DashboardController.php:23
* @route '/app/member'
*/
overviewForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: overview.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

overview.form = overviewForm

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
export const manage = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manage.url(args, options),
    method: 'get',
})

manage.definition = {
    methods: ["get","head"],
    url: '/app/member/manage/{subscription}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
manage.url = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { subscription: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { subscription: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            subscription: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        subscription: typeof args.subscription === 'object'
        ? args.subscription.uuid
        : args.subscription,
    }

    return manage.definition.url
            .replace('{subscription}', parsedArgs.subscription.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
manage.get = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: manage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
manage.head = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: manage.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
const manageForm = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
manageForm.get = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::manage
* @see app/Http/Controllers/Member/DashboardController.php:91
* @route '/app/member/manage/{subscription}'
*/
manageForm.head = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: manage.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

manage.form = manageForm

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
export const payments = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payments.url(options),
    method: 'get',
})

payments.definition = {
    methods: ["get","head"],
    url: '/app/member/payments',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
payments.url = (options?: RouteQueryOptions) => {
    return payments.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
payments.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payments.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
payments.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: payments.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
const paymentsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payments.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
paymentsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payments.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::payments
* @see app/Http/Controllers/Member/DashboardController.php:159
* @route '/app/member/payments'
*/
paymentsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payments.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

payments.form = paymentsForm

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
export const purchases = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: purchases.url(options),
    method: 'get',
})

purchases.definition = {
    methods: ["get","head"],
    url: '/app/member/purchases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
purchases.url = (options?: RouteQueryOptions) => {
    return purchases.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
purchases.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: purchases.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
purchases.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: purchases.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
const purchasesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: purchases.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
purchasesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: purchases.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\DashboardController::purchases
* @see app/Http/Controllers/Member/DashboardController.php:241
* @route '/app/member/purchases'
*/
purchasesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: purchases.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

purchases.form = purchasesForm

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
export const cancel = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cancel.url(options),
    method: 'get',
})

cancel.definition = {
    methods: ["get","head"],
    url: '/app/member/cancel',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
cancel.url = (options?: RouteQueryOptions) => {
    return cancel.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
cancel.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cancel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
cancel.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cancel.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
const cancelForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cancel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
cancelForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cancel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\CancelController::__invoke
* @see app/Http/Controllers/Member/CancelController.php:12
* @route '/app/member/cancel'
*/
cancelForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cancel.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
export const inbox = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: inbox.url(options),
    method: 'get',
})

inbox.definition = {
    methods: ["get","head"],
    url: '/app/member/inbox',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
inbox.url = (options?: RouteQueryOptions) => {
    return inbox.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
inbox.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
inbox.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: inbox.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
const inboxForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
inboxForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\InboxController::inbox
* @see app/Http/Controllers/Member/InboxController.php:25
* @route '/app/member/inbox'
*/
inboxForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

inbox.form = inboxForm

const member = {
    overview: Object.assign(overview, overview),
    manage: Object.assign(manage, manage),
    payments: Object.assign(payments, payments4e2b3d),
    purchases: Object.assign(purchases, purchases),
    contributions: Object.assign(contributions, contributions),
    cancel: Object.assign(cancel, cancel),
    inbox: Object.assign(inbox, inbox43de3a),
}

export default member